'use client';

import React, { useMemo } from 'react';

import { TasticProps } from '../types';
import {
  AlgoliaRecommendationProvider,
  TrendingFacetsItems,
} from 'components/commercetools-ui/organisms/product/product-recommendations';
import { useBadgeLoader } from 'helpers/utils/badgeLoader';
import { P2Badge } from 'components/commercetools-ui/organisms/product/product-list-algolia/types';
import { shouldShowRecommendation } from 'helpers/utils/recommendationUtils';

const AlgoliaTrendingFacetProductTastic = ({ data }: TasticProps<any>) => {
  if (!data?.isEnableFacetTrending) return <></>;
  const p1BadgeData = data?.data?.dataSource?.p1BadgeData;
  const p2BadgeData = data?.data?.dataSource?.p2BadgeData;
  const p1Badges = useBadgeLoader(p1BadgeData?.productListingContent);
  const p2Badges = p2BadgeData?.productListingContent as P2Badge[];
  const recommendationsConfig = data?.data?.dataSource?.includeExclude?.recommendations || [];
  const currentUrl = typeof window !== 'undefined' ? window.location.pathname : '';

  const recFlags = useMemo(() => {
    return shouldShowRecommendation(
      currentUrl,
      recommendationsConfig,
      'trendingFacetsValue',
      data?.isEnableTrending,
      data?.isPLP,
    );
  }, [currentUrl, recommendationsConfig, data?.isEnableTrending]);

  if (!recFlags) return null;
  return (
    <AlgoliaRecommendationProvider>
      <div>
        <TrendingFacetsItems title={data?.trendingTitle} p1BadgeData={p1Badges} p2BadgeData={p2Badges} />
      </div>
    </AlgoliaRecommendationProvider>
  );
};

export default AlgoliaTrendingFacetProductTastic;
